export const SET_ROOMS = 'SET_ROOMS';
export const UPDATE_ROOMS = 'UPDATE_ROOMS';
